import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function autocompleteModelValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isModel = control.value && !(typeof control.value === 'string');

        return isModel ? null : {'invalidModel': { value: control.value }};
    };
}
